import React, { useState } from 'react';
import { EditOwnersModal, OperationType } from '../../../../containers/profile/sidebar/Ownership/EditOwnersModal';
import ActionDropdown from './ActionDropdown';
import { useTranslation } from '../../../../../../../i18n/useTranslation';

type Props = {
    urns: Array<string>;
    disabled: boolean;
    refetch?: () => void;
    tooltip?: string;
};

// eslint-disable-next-line
export default function OwnersDropdown({ urns, disabled = false, refetch, tooltip }: Props) {
    const { t } = useTranslation();
    const [isEditModalVisible, setIsEditModalVisible] = useState(false);
    const [operationType, setOperationType] = useState(OperationType.ADD);

    return (
        <>
            <ActionDropdown
                name={t('Owners')}
                actions={[
                    {
                        title: t('Add owners'),
                        onClick: () => {
                            setOperationType(OperationType.ADD);
                            setIsEditModalVisible(true);
                        },
                    },
                    {
                        title: t('Remove owners'),
                        onClick: () => {
                            setOperationType(OperationType.REMOVE);
                            setIsEditModalVisible(true);
                        },
                    },
                ]}
                disabled={disabled}
                tooltip={tooltip}
            />
            {isEditModalVisible && (
                <EditOwnersModal
                    urns={urns}
                    operationType={operationType}
                    onCloseModal={() => {
                        setIsEditModalVisible(false);
                        refetch?.();
                    }}
                    hideOwnerType={operationType === OperationType.REMOVE}
                />
            )}
        </>
    );
}
